import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SuggestionNotifyComponent } from './suggestion-notify.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [SuggestionNotifyComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatBadgeModule,
    MatButtonModule
  ],
  exports: [SuggestionNotifyComponent]
})
export class SuggestionNotifyModule {}
